import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import CardPaper from './CardPaper'
import { IconButton } from '../default'
import { RegisterCustomerModal } from '../modal'
import { useHistory } from 'react-router-dom'
import { ROUTER } from '../../class/constants'
import { Block, PersonAdd } from '@material-ui/icons'

const CUSTOMER_MODALS = {
  REGISTER: 1
}

function CardCustomer({
  classes
}) {
  const { t } = useTranslation()
  const history = useHistory()

  const [currentModal, setCurrentModal] = useState(null)

  const loadRegisterCustomerModal = () => {
    setCurrentModal(CUSTOMER_MODALS.REGISTER)
  }

  const loadBlockCustomer = () => {
    return history.push({
      pathname: ROUTER.BLOCK
    })
  }

  return (
    <div className={classes.form}>
      <RegisterCustomerModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === CUSTOMER_MODALS.REGISTER} />
      <Grid container xs={12} md={8} lg={6} xl={4} spacing={1} justifyContent='center'>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadRegisterCustomerModal}
              icon={PersonAdd}
            >
              {t('cards.customer.btnRegister')}
            </IconButton>
          </CardPaper>
        </Grid>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadBlockCustomer}
              icon={Block}
            >
              {t('cards.customer.btnBlock')}
            </IconButton>
          </CardPaper>
        </Grid>
      </Grid>
    </div>
  )
}

CardCustomer.propTypes = {
  onSearch: PropTypes.func,
}

CardCustomer.defaultProps = {
  onSearch: () => true
}

const styles = theme => ({
  header: {
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  formField: {
    width: '100%', 
    height: '100%'
  },
  gridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  }
})

export default withStyles(styles)(CardCustomer)